import { LayoutHOC } from 'base/ui/layout/layout';
import createFeedback from '.';

export const createFeedbackPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createFeedback());
};
